// ─── Date ───────────────────────────────────────────────────────────────────

export function fmtDate(ts: string | null | undefined) {
  if (!ts) return '—'
  return new Date(ts.endsWith('Z') ? ts : ts + 'Z').toLocaleDateString('de-DE', {
    day: '2-digit', month: '2-digit', year: 'numeric',
  })
}

// Backend expects local ISO timestamps (without Z). Start = start of day, end = end of day.
export function toIso(dateStr: string, endOfDay = false) {
  if (!dateStr) return ''
  return endOfDay ? `${dateStr}T23:59:59` : `${dateStr}T00:00:00`
}

// Default filter: current week (Mon–Sun), like the old portal.
export function getWeekRange() {
  const now = new Date()
  const day = now.getDay() || 7
  const mon = new Date(now); mon.setDate(now.getDate() - day + 1)
  const sun = new Date(now); sun.setDate(now.getDate() - day + 7)
  const fmt = (d: Date) => d.toISOString().slice(0, 10)
  return { start: fmt(mon), end: fmt(sun) }
}
